import React from 'react'
import { 
    ArtefactsContainer, 
    ArtefactCard,
    ArtefactWrapper,
    ArtefactsHeading,
    ArtefactsHeading1,
    Title, 
    Desc, 
    ArtefactInfo,

} from './BidayuhArtefacts';

import '../../../../App.css';
import {useState} from 'react'; 
import {GiSpellBook} from 'react-icons/gi';
import {AiOutlineSearch} from 'react-icons/ai';
import { MelayuFolkloresList } from './data';


const MelayuFolklores = (props)=> {

    const [searchTerm, setSearchTerm] = useState ("");

    return (
            <ArtefactsContainer> 
            
                <ArtefactsHeading> Malay Folklores </ArtefactsHeading>
                        <label className = "label"> <AiOutlineSearch/> Filter Arterfect </label>
                        <input className = "searchbox"
                            type = "text"
                            placeholder= " Unwrap your heritage " 
                            onChange = {(event) => {
                                setSearchTerm(event.target.value);
                            }}
                        />
                   
                    <ArtefactsHeading1> 
                        <GiSpellBook/> Folklores 
                    </ArtefactsHeading1>

                    <ArtefactWrapper> 
                        {MelayuFolkloresList.filter ((artefact) => {
                            if (searchTerm == "") {
                                return artefact
                            } else if (artefact.name.toLowerCase().includes (searchTerm.toLowerCase())) {
                                return artefact
                            }
                        }).map((artefact, key) => {
                    return (
                    <ArtefactCard key={key}> 
                        
                            <ArtefactInfo> 
                                <Title> {artefact.name} </Title> 
                                <Desc> {artefact.description} </Desc>
                            </ArtefactInfo>
                    </ArtefactCard>   
                    );
                    })}
                    </ArtefactWrapper>
                        
            </ArtefactsContainer>
    );
};

export default MelayuFolklores
